import React from 'react';
import PropTypes from 'prop-types';
import { SuiContainer } from '@splashthat/sui';
import { Body } from '@splashthat/doppler/Typography';

import { NoResultsImage } from './NoResultsFound.styles';

const NO_RESULTS_MESSAGE = 'We searched far and wide, but could not find any results.';

export default function NoResultsFound({ qaId, noResultsMessage }) {
    return (
        <SuiContainer
            className={`${qaId}_no-results-container`}
            variation="flex full-height full-width flex-center padded"
        >
            <SuiContainer variation="flex-group">
                <Body as="p">{noResultsMessage}</Body>
            </SuiContainer>
            <NoResultsImage variation="flex-group" grow={1} className={`${qaId}_no-results-illo`} />
        </SuiContainer>
    );
}

NoResultsFound.propTypes = {
    qaId: PropTypes.string,
    noResultsMessage: PropTypes.string,
};

NoResultsFound.defaultProps = {
    qaId: 'NoResultsFound',
    noResultsMessage: NO_RESULTS_MESSAGE,
};
